import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr'
import { ToastController } from '@ionic/angular';
import { PmsYearService } from 'src/app/services/pms-year.service';
import { delay } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

interface Month {
  key: number;
  name: string;
}
@Component({
  selector: 'app-attritionsetup',
  templateUrl: './attritionsetup.component.html',
  styleUrls: ['./attritionsetup.component.scss'],
})
export class AttritionsetupComponent implements OnInit {

  attritionSetupForm!: FormGroup;




  //  FormRepeater in table 
  ageGroupBucketsInput: boolean = false;
  yearBucketsInput: boolean = false;
  performanceBucketsInput: boolean = false;
  potentialBucketsInput: boolean = false;
  essScoreBucketsInput: boolean = false;
  salaryBucketsInput: boolean = false;
  incrementBucketsInput: boolean = false;
  vpAmountBucketsInput: boolean = false;
  lowerRange: number | any = null;

  maxRange: number | any = null;
  scoreRange: number | any = null;
  errMsgMaxRange: boolean = false;
  showMaxRangeError: boolean = false;
  errorMessage: string = '';
  restrictToEditSetup: boolean = false;
  isInValidMaxRange: boolean = false;
  selectedBucket: string = ''; // Default selected bucket
  showInputsAge: boolean = false;
  showInputsExperience: boolean = false;
  maxRangeAge: number | any = null;
  maxRangeExperience: number | any = null;
  scoreRangeAge: number = 0;
  scoreRangeExperience: number = 0;
  errMsgMaxRangeAge: boolean = false;
  errMsgMaxRangeExperience: boolean = false;
  isInValidMaxRangeAge: boolean = false;
  isInValidMaxRangeExperience: boolean = false;




  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  setupGradeBrand: any;
  setUpyearRange: any;
  loggedInUserEmpCode: any | null;
  buttonColorName: any | null;
  subModuleButtonColor: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserName: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  loggedInUserCompanyID: any;
  selectedYearForCompetency: any = null;
  selectedYear: any = null;

  fromYear: any;
  toYear: any;
  arrAllMonths: any = [];
  selectedMonth: any;

  ageGroupBuckets: any;
  yearBuckets: any;
  performanceBuckets: any;
  potentialBuckets: any;
  essScoreBuckets: any;
  salaryBuckets: any;
  incrementBuckets: any;
  vpAmountBuckets: any;

  // units = ['LPA', 'Cr', 'K'];
  selectedUnit: any;

  selectedMonthName: any;
  previousMonthsCountJanDec: any;
  previousMonthsCountAprilMarch: any;
  constructor(public router: Router,
    private fb: FormBuilder,
    public sharedService: SharedService,
    private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config,
    public dialog: MatDialog,
    private snackbar: MatSnackBar, private toastr: ToastrService,
    private toastController: ToastController,
    private PmsYearService: PmsYearService,
        private dataRefreshService: DataRefreshService,
    
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.attritionSetupForm = this.fb.group({
      fiscalYear: [null],  // you can set an initial value if needed
      year: [null, Validators.required]
    });

    // this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    // console.log(this.loggedInUserCompanyID,this.selectedYear, this.selectedMonth)
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    console.log(this.loggedInUserCompanyID)
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = Number(sessionStorage.getItem('loggedInUserId'));
    console.log("loggedInUserId", this.loggedInUserId)
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    // this.updateYearControl(this.loggedInCompanyFiscalyear);
    // this.getAllFunctionsByYearRangeReport();
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
    // this.fetchagegroupbucket();
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     console.log(data)
  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`;
  //       } else {
  //         yearValue = `${currentYear}-${currentYear + 1}`;
  //       }

  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;
  //         var test = ele?.year?.split('-');

  //       }
  //     });
  //     this.selectedYearForCompetency = this.pmsYears[1].year;

  //       console.error(this.pmsYears)


  //     // Call additional functions if needed

  //     var year = this.selectedYearForCompetency?.split('-');
  //     if (year?.length != 0) {
  //       this.fromYear = year[0];
  //       this.toYear = year[1];
  //     }
  //     this.fetchBucket();
  //     this.getMonths(this.fromYear, this.toYear)
  //     // this.selectedMonth = new Date().getMonth() + 1;
  //     // console.log(this.selectedMonth)
  //   });
  // }


  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     const currentYear = new Date().getFullYear();

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       let test = ele.split('_');
  //       let fromYear = parseInt(test[0]);
  //       let toYear = parseInt(test[1]);
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         if (toYear <= currentYear) {
  //           this.pmsYears.push({ year: `${fromYear}-${toYear}` });
  //         }
  //       } else {
  //         if (toYear <= currentYear + 1) {
  //           this.pmsYears.push({ year: `${fromYear}-${toYear}` });
  //         }
  //       }
  //     });

  //     this.pmsYears.sort((a: { year: string }, b: { year: string }) => {
  //       let [aStart, aEnd] = a.year.split('-').map(Number);
  //       let [bStart, bEnd] = b.year.split('-').map(Number);
  //       return bEnd - aEnd;
  //     });

  //     if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //       this.selectedYearForCompetency = `${currentYear}-${currentYear}`;
  //     } else {
  //       this.selectedYearForCompetency = `${currentYear}-${currentYear + 1}`;
  //     }

  //     console.log("Selected Fiscal Year:", this.selectedYearForCompetency);

  //     console.log("Final Dropdown Options:", this.pmsYears);

  //     this.selectedYear = this.selectedYearForCompetency;

  //     let year = this.selectedYearForCompetency?.split('-');
  //     if (year?.length != 0) {
  //       this.fromYear = year[0];
  //       this.toYear = year[1];
  //     }
  //     this.fetchBucket();
  //     this.getMonths(this.fromYear, this.toYear);
  //   });
  // }

  
      getpmsyearlist() {
        this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
          this.pmsYears = formatYearRanges(data?.data?.yearRanges);
    
          const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    
          const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
          this.setSelectedYear(yearValue);
  
          this.getMonths(this.fromYear, this.toYear);
        });
      }
      setSelectedYear(yearValue: string): void {
        const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
        if (selectedYearObj) {
              this.selectedYearForCompetency = selectedYearObj?.year;
             
              let test = selectedYearObj?.year.split('-');
              this.fromYear = test[0];
              this.toYear = test[1];
        }
      }
  getYearSetupForReimbursement(year: any) {
    this.selectedYear = year;
    console.log(this.selectedYear)
    this.getMonths(this.fromYear, this.toYear)

    this.fetchBucket();
  }

  fiscalYearMonthsAprilMarch = [
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
  ];

  fiscalYearMonthsJanDec = [
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
  ];




  getMonths(fromYear: any, toYear: any) {
    this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec') ? this.fiscalYearMonthsJanDec : this.fiscalYearMonthsAprilMarch;
    this.selectedMonth = new Date().getMonth() + 1;


    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Find index of selected month for fiscalYearMonthsJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January

    console.log('Selected Month Name:', this.selectedMonthName, "selectedMonth", this.selectedMonth, "previousMonthsCountAprilMarch", this.previousMonthsCountAprilMarch, "previousMonthsCountJanDec", this.previousMonthsCountJanDec);
    this.fetchBucket();
  }

  onMonthChange(event: any) {
    const selectedMonthKey = event.value;
    this.selectedMonth = selectedMonthKey;


    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Find index of selected month for fiscalYearMonthsJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January

    console.log('Selected Month Name:', this.selectedMonthName, "selectedMonth", this.selectedMonth, "previousMonthsCountAprilMarch", this.previousMonthsCountAprilMarch, "previousMonthsCountJanDec", this.previousMonthsCountJanDec);
    this.fetchBucket();

  }

  onClickback() {
    this.router.navigate(['/home/hrportal/attrition'], { queryParamsHandling: 'merge' }).then(() => {
      this.router.onSameUrlNavigation = 'reload';
    });
  }

  preventNegative(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'e' || event.key === '+') {
      event.preventDefault();
    }
  }

  removeInputs() {
    if (this.selectedBucket === 'ageGroupBuckets') {
      this.ageGroupBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'yearBuckets') {

      this.yearBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'performanceBuckets') {
      this.performanceBucketsInput = false;
      this.resetFormFields();
    }
    else if (this.selectedBucket === 'potentialBuckets') {
      this.potentialBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'essScoreBuckets') {
      this.essScoreBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'salaryBuckets') {
      this.salaryBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'incrementBuckets') {
      this.incrementBucketsInput = false;
      this.resetFormFields();
    } else if (this.selectedBucket === 'vpAmountBuckets') {
      this.vpAmountBucketsInput = false;
      this.resetFormFields();
    }
    this.ageGroupBucketsInput = false;

    this.yearBucketsInput = false;

    this.performanceBucketsInput = false;

    this.potentialBucketsInput = false;

    this.essScoreBucketsInput = false;

    this.salaryBucketsInput = false;

    this.incrementBucketsInput = false;

    this.vpAmountBucketsInput = false;
    this.resetFormFields();
  }

  resetFormFields() {
    this.scoreRange = null;
    this.maxRange = null;
    this.isInValidMaxRange = false;
    this.selectedUnit = '';
  }
  toggleInputs(bucketType: string) {
    this.maxRange = null;

    this.selectedBucket = bucketType;
    const selectedBuckets = this.getBucketArray(bucketType);
    console.log("bucketType", bucketType);

    if (selectedBuckets.length > 0) {
      this.selectedUnit = selectedBuckets[0].unit; // Use first unit if available
    } else {
      this.selectedUnit = ''; // Allow user to input a new unit
    }

    if (this.selectedBucket === 'ageGroupBuckets') {


      this.yearBucketsInput = false;

      this.performanceBucketsInput = false;

      this.potentialBucketsInput = false;

      this.essScoreBucketsInput = false;

      this.salaryBucketsInput = false;

      this.incrementBucketsInput = false;

      this.vpAmountBucketsInput = false;

      if (this.ageGroupBucketsInput) {
        this.saveData();
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        // this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].higherEnd) : 0;
        // If no buckets exist, allow entering both Lower and Higher End
        if (selectedBuckets.length === 0) {
          this.scoreRange = null; // Allow manual input
        } else {
          this.scoreRange = Number(selectedBuckets[selectedBuckets.length - 1].ageBucketMax);
        }
      }
      this.ageGroupBucketsInput = !this.ageGroupBucketsInput;

    } else if (this.selectedBucket === 'yearBuckets') {
      this.ageGroupBucketsInput = false;
      this.performanceBucketsInput = false;
      this.potentialBucketsInput = false;
      this.essScoreBucketsInput = false;
      this.salaryBucketsInput = false;
      this.incrementBucketsInput = false;
      this.vpAmountBucketsInput = false;
      if (this.yearBucketsInput) {
        this.saveData();
        this.yearBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].yearBucketMax) : 0;
      }
      this.yearBucketsInput = !this.yearBucketsInput;

    } else if (this.selectedBucket === 'performanceBuckets') {
      this.ageGroupBucketsInput = false;
      this.yearBucketsInput = false;
      this.potentialBucketsInput = false;
      this.essScoreBucketsInput = false;
      this.salaryBucketsInput = false;
      this.incrementBucketsInput = false;
      this.vpAmountBucketsInput = false;
      if (this.performanceBucketsInput) {
        this.saveData();
        this.performanceBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].upperEnd) : 0;
      }
      this.performanceBucketsInput = !this.performanceBucketsInput;

    } else if (this.selectedBucket === 'potentialBuckets') {
      this.ageGroupBucketsInput = false;
      this.yearBucketsInput = false;
      this.performanceBucketsInput = false;
      this.essScoreBucketsInput = false;
      this.salaryBucketsInput = false;
      this.incrementBucketsInput = false;
      this.vpAmountBucketsInput = false;
      if (this.potentialBucketsInput) {
        this.saveData();
        this.potentialBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        if (this.isLastMaxRange100(selectedBuckets)) {
          alert('Max Range of 100 already reached. You cannot add more ranges.');
          return;
        }
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].upperEnd) : 0;
      }
      this.potentialBucketsInput = !this.potentialBucketsInput;

    } else if (this.selectedBucket === 'essScoreBuckets') {
      this.ageGroupBucketsInput = false;
      this.yearBucketsInput = false;
      this.performanceBucketsInput = false;
      this.potentialBucketsInput = false;
      this.salaryBucketsInput = false;
      this.incrementBucketsInput = false;
      this.vpAmountBucketsInput = false;
      if (this.essScoreBucketsInput) {
        this.saveData();
        this.essScoreBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].upperEnd) : 0;
      }
      this.essScoreBucketsInput = !this.essScoreBucketsInput;

    } else if (this.selectedBucket === 'salaryBuckets') {
      this.ageGroupBucketsInput = false;
      this.yearBucketsInput = false;
      this.performanceBucketsInput = false;
      this.potentialBucketsInput = false;
      this.essScoreBucketsInput = false;
      this.incrementBucketsInput = false;
      this.vpAmountBucketsInput = false;
      if (this.salaryBucketsInput) {
        this.saveData();
        this.salaryBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].upperEnd) : 0;
      }
      // Set Lower End dynamically
      if (selectedBuckets.length > 0) {
        this.scoreRange = selectedBuckets[selectedBuckets.length - 1].upperEnd;
      } else {
        this.scoreRange = null; // Allow user input for the first entry
      }
      this.salaryBucketsInput = !this.salaryBucketsInput;

    } else if (this.selectedBucket === 'incrementBuckets') {
      this.ageGroupBucketsInput = false;
      this.yearBucketsInput = false;

      this.performanceBucketsInput = false;
      this.potentialBucketsInput = false;
      this.essScoreBucketsInput = false;
      this.salaryBucketsInput = false;
      this.vpAmountBucketsInput = false;
      if (this.incrementBucketsInput) {
        this.saveData();
        this.incrementBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].upperEnd) : 0;
      }
      this.incrementBucketsInput = !this.incrementBucketsInput;

    } else if (this.selectedBucket === 'vpAmountBuckets') {
      this.ageGroupBucketsInput = false;
      this.yearBucketsInput = false;
      this.performanceBucketsInput = false;
      this.potentialBucketsInput = false;
      this.essScoreBucketsInput = false;
      this.salaryBucketsInput = false;
      this.incrementBucketsInput = false;
      if (this.vpAmountBucketsInput) {
        this.saveData();
        this.vpAmountBucketsInput = false; // Ensure input field is hidden after saving
      } else {
        this.scoreRange = selectedBuckets.length > 0 ? Number(selectedBuckets[selectedBuckets.length - 1].upperEnd) : 0;
      }
      // Set Lower End dynamically
      if (selectedBuckets.length > 0) {
        this.scoreRange = selectedBuckets[selectedBuckets.length - 1].upperEnd;
      } else {
        this.scoreRange = null; // Allow user input for the first entry
      }
      this.vpAmountBucketsInput = !this.vpAmountBucketsInput;
    }
  }

  isLastMaxRange100(bucketArray: any[]): boolean {
    if (!Array.isArray(bucketArray) || bucketArray.length === 0) {
      return false;
    }
    return Number(bucketArray[bucketArray.length - 1]?.ageBucketMax) === 100;
  }
  isLastMaxRange100Years(bucketArray: any[]): boolean {
    if (!Array.isArray(bucketArray) || bucketArray.length === 0) {
      return false;
    }
    return Number(bucketArray[bucketArray.length - 1]?.yearBucketMax) === 100;
  }
  loading: boolean = false;

  saveData() {
    this.loading = true;

    this.showMaxRangeError = false;
    if (this.maxRange == null) {
      this.errMsgMaxRange = true;
      return;
    }
    this.errMsgMaxRange = false;
    const maxRangeNum = Number(this.maxRange);

    // if (maxRangeNum > 100) {
    if ((this.ageGroupBucketsInput || this.yearBucketsInput) && maxRangeNum > 100) {
      // alert('Validation failed: max range cannot exceed 100.');
      // return;
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Validation failed: max range cannot exceed 100.',
          btn1: 'OK',
          btn2: '',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });

      return;
    }

    const selectedBuckets = this.getBucketArray(this.selectedBucket);
    if (['vpAmountBuckets', 'salaryBuckets'].includes(this.selectedBucket)) {
      if (selectedBuckets.length > 0) {
        this.selectedUnit = selectedBuckets[0].unit; // Use the first unit if data exists
      } else if (!this.selectedUnit) {
        alert('Please enter a unit (LPA, Cr, K) before saving.');
        return;
      }
    }

    if (this.isLastMaxRange100(selectedBuckets) && maxRangeNum !== 100) {
      alert('Validation failed: The maximum range must be 100 to proceed.');
      return;
    }
    if (this.selectedBucket === 'ageGroupBuckets') {
      this.ageGroupBucketsInput = false;

      console.log("selectedBucket", this.selectedBucket);
      const payload = [{
        ageBucketLow: Number(this.scoreRange),
        ageBucketMax: Number(this.maxRange),
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      console.log('payload Age Group Bucket:', payload);
      this.httpService.callPostService(`${this.config.ageBucketpostUrl}`, payload)
        //  .pipe(delay(10000)) 
        .subscribe({
          next: (result: any) => {
            if (result) {
              console.log(result);
              
            this.dataRefreshService.triggerRefresh();
              // this.snackbar.open("The bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false

                },
              });
              this.fetchagegroupbucket();
            } this.loading = false;
          },
          error: (err: any) => {
            console.error("Error saving bucket:", err);
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error?.message || "Failed to save the bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });
    } else if (this.selectedBucket === 'yearBuckets') {
      console.log("selectedBucket", this.selectedBucket);
      this.yearBucketsInput = false;

      const payload = [{
        yearBucketLow: Number(this.scoreRange),
        yearBucketMax: Number(this.maxRange),
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      console.log('payload yearBuckets :', payload);
      this.httpService.callPostService(`${this.config.yearBucketpostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              console.log(result);
              // this.snackbar.open("The bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchYearBuckets();
            } this.loading = false;
          },
          error: (err: any) => {
            console.error("Error saving bucket:", err);
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error?.message || "Failed to save the bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });
    }
    else if (this.selectedBucket === 'performanceBuckets') {
      console.log("selectedBucket", this.selectedBucket);
      this.performanceBucketsInput = false;

      const payload = [{
        lowerEnd: Number(this.scoreRange),
        upperEnd: Number(this.maxRange),
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      console.log('payload performanceBuckets :', payload);
      this.httpService.callPostService(`${this.config.performanceBucketsPostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              console.log(result);
              // this.snackbar.open("The bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchPerformanceBuckets();
            } this.loading = false;
          },
          error: (err: any) => {
            console.error("Error saving bucket:", err);
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error?.message || "Failed to save the bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });
    }
    else if (this.selectedBucket === 'potentialBuckets') {
      this.potentialBucketsInput = false;

      const payload = [{
        lowerEnd: Number(this.scoreRange),
        upperEnd: Number(this.maxRange),
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      this.httpService.callPostService(`${this.config.potentialBucketPostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              console.log(result)
              // this.snackbar.open("The Potential Bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchPotentialBuckets(); // Refresh data
            } this.loading = false;
          },
          error: (err: any) => {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error.message || "Failed to save Bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });
    }
    else if (this.selectedBucket === 'essScoreBuckets') {
      console.log("selectedBucket", this.selectedBucket);
      this.essScoreBucketsInput = false;

      const payload = [{
        lowerEnd: Number(this.scoreRange),
        upperEnd: Number(this.maxRange),
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      this.httpService.callPostService(`${this.config.essScoreBucketPostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              // this.snackbar.open("The ESS Score Bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchEssScoreBuckets(); // Refresh data
            } this.loading = false;
          },
          error: (err: any) => {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error.message || "Failed to save Bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });
    }
    else if (this.selectedBucket === 'salaryBuckets') {
      this.salaryBucketsInput = false;

      const payload = [{
        lowerEnd: Number(this.scoreRange),
        upperEnd: Number(this.maxRange),
        unit: this.selectedUnit,
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      this.httpService.callPostService(`${this.config.salaryBucketPostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              // this.snackbar.open("The Salary Bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchSalaryBuckets(); // Refresh data
            } this.loading = false;
          },
          error: (err: any) => {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error.message || "Failed to save Bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });
    }
    else if (this.selectedBucket === 'incrementBuckets') {
      console.log("selectedBucket", this.selectedBucket);
      this.incrementBucketsInput = false;

      const payload = [{
        lowerEnd: Number(this.scoreRange),
        upperEnd: Number(this.maxRange),
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];

      this.httpService.callPostService(`${this.config.incrementBucketPostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              // this.snackbar.open("The Increment Bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchIncrementBuckets(); // Refresh data
            } this.loading = false;
          },
          error: (err: any) => {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error.message || "Failed to save Bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });

    }
    else if (this.selectedBucket === 'vpAmountBuckets') {
      this.vpAmountBucketsInput = false;
      const payload = [{
        lowerEnd: Number(this.scoreRange),
        upperEnd: Number(this.maxRange),
        unit: this.selectedUnit,
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForCompetency,
        hrAdminId: this.loggedInUserId
      }];
      console.log(payload);
      this.httpService.callPostService(`${this.config.vpAmountBucketPostUrl}`, payload)
        .subscribe({
          next: (result: any) => {
            if (result) {
              // this.snackbar.open("The VP Amount Bucket has been saved successfully.", "Close", { duration: 2000 });
              this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'The Bucket has been saved successfully.',
                  btn1: 'Close',
                  btn2: '',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                },
              });
              this.fetchVpAmountBuckets(); // Refresh data
            } this.loading = false;
          },
          error: (err: any) => {
            this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: err.error.message || "Failed to save Bucket.",
                btn1: 'Close',
                btn2: '',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            }); this.loading = false;
          }
        });

    }


    this.resetFormFields();
    this.ageGroupBucketsInput = false;
    this.yearBucketsInput = false;

    this.performanceBucketsInput = false;
    this.potentialBucketsInput = false;
    this.essScoreBucketsInput = false;
    this.salaryBucketsInput = false;
    this.incrementBucketsInput = false;
    this.vpAmountBucketsInput = false;
  }
  getBucketArray(bucketType: string): any[] {
    switch (bucketType) {
      case 'ageGroupBuckets': return (this.ageGroupBuckets) ? this.ageGroupBuckets : [];
      case 'yearBuckets': return (this.yearBuckets) ? this.yearBuckets : [];
      case 'performanceBuckets': return (this.performanceBuckets) ? this.performanceBuckets : [];
      case 'potentialBuckets': return (this.potentialBuckets) ? this.potentialBuckets : [];
      case 'essScoreBuckets': return (this.essScoreBuckets) ? this.essScoreBuckets : [];
      case 'salaryBuckets': return (this.salaryBuckets) ? this.salaryBuckets : [];
      case 'incrementBuckets': return (this.incrementBuckets) ? this.incrementBuckets : [];
      case 'vpAmountBuckets': return (this.vpAmountBuckets) ? this.vpAmountBuckets : [];
      default: return [];
    }
  }
  onMaxRangeChange(data: { maxRange: number | string; minRange: number }): void {
    // console.log("maxRange:", this.maxRange, "scoreRange:", this.scoreRange);

    const maxRange = typeof data.maxRange === 'string' ? Number(data.maxRange) : data.maxRange;
    if (isNaN(maxRange) || maxRange <= data.minRange || maxRange <= 0) {
      this.isInValidMaxRange = true;
      this.maxRange = null;
    } else {
      this.isInValidMaxRange = false;
    }
  }
  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }


  deleteBucket(bucketType: string) {


    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete this Bucket?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (bucketType) {
          case 'ageGroupBuckets':
            // this.ageGroupBuckets = [];
            const payload = {
              "companyId": this.loggedInUserCompanyID,
              "fiscalYear": this.selectedYearForCompetency,
              "deletedBy": this.loggedInUserId
            };

            this.httpService.callPutService(`${this.config.ageBucketdeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`, payload)
              .subscribe({
                next: async (result: any) => {
                  // this.snackbar.open("The bucket has been deleted successfully.", "Close", { duration: 2000 });
                  this.dialog.open(ConfirmationPopupComponent, {
                    disableClose: true,
                    height: '25%',
                    width: '30%',
                    data: {
                      msg: 'The bucket has been deleted successfully.',
                      btn1: 'Close',
                      btn2: '',
                      btn2BgColor: this.buttonColorName,
                      showSuccessIcon: true,
                      showSuccessMessage: false,
                      showCloseIcon: false
                    },
                  });
                  this.fetchagegroupbucket();
                },
                error: async (err: any) => {
                  this.dialog.open(ConfirmationPopupComponent, {
                    disableClose: true,
                    height: '25%',
                    width: '30%',
                    data: {
                      msg: err.error.message || "Failed to delete the bucket.",
                      btn1: 'Close',
                      btn2: '',
                      btn2BgColor: this.buttonColorName,
                      showSuccessIcon: false,
                      showSuccessMessage: false,
                      showCloseIcon: false
                    },
                  });
                }
              });

            break;
          case 'yearBuckets':
            // this.yearBuckets = [];
            const payloadyearBuckets = {
              "companyId": this.loggedInUserCompanyID,
              "fiscalYear": this.selectedYearForCompetency,
              "deletedBy": this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.yearBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              payloadyearBuckets
            ).subscribe({
              next: async (result: any) => {
                // this.snackbar.open("The bucket has been deleted successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchYearBuckets(); // Call method to refresh data
              },
              error: async (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });
            break;
          case 'performanceBuckets':
            // this.performanceBuckets = [];

            const payloadPerformanceBucket = {
              companyId: this.loggedInUserCompanyID,
              fiscalYear: this.selectedYearForCompetency,
              deletedBy: this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.performanceBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              payloadPerformanceBucket
            ).subscribe({
              next: async (result: any) => {
                // this.snackbar.open("The performance bucket has been deleted successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchPerformanceBuckets(); // Refresh data after deletion
              },
              error: async (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });
            break;
          case 'potentialBuckets':
            // this.potentialBuckets = [];

            const payloadPotentialBucket = {
              companyId: this.loggedInUserCompanyID,
              fiscalYear: this.selectedYearForCompetency,
              deletedBy: this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.potentialBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              payloadPotentialBucket
            ).subscribe({
              next: async (result: any) => {
                // this.snackbar.open("The Potential Bucket has been deleted successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchPotentialBuckets(); // Refresh data after deletion
              },
              error: async (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });
            break;
          case 'essScoreBuckets':
            // this.essScoreBuckets = [];

            const payloadEssScoreBucket = {
              companyId: this.loggedInUserCompanyID,
              fiscalYear: this.selectedYearForCompetency,
              deletedBy: this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.essScoreBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              payloadEssScoreBucket
            ).subscribe({
              next: async (result: any) => {
                // this.snackbar.open("The ESS Score Bucket has been deleted successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchEssScoreBuckets(); // Refresh data after deletion
              },
              error: async (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });

            break;
          case 'salaryBuckets':
            // this.salaryBuckets = [];

            const payloadSalaryBucket = {
              companyId: this.loggedInUserCompanyID,
              fiscalYear: this.selectedYearForCompetency,
              deletedBy: this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.salaryBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              payloadSalaryBucket
            ).subscribe({
              next: async (result: any) => {
                // this.snackbar.open("The Salary Bucket has been deleted successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchSalaryBuckets(); // Refresh data after deletion
              },
              error: async (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });
            break;
          case 'incrementBuckets':
            // this.incrementBuckets = [];
            const payloadIncrementBucket = {
              companyId: this.loggedInUserCompanyID,
              fiscalYear: this.selectedYearForCompetency,
              deletedBy: this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.incrementBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              payloadIncrementBucket
            ).subscribe({
              next: async (result: any) => {
                // this.snackbar.open("The Increment Bucket has been deleted successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchIncrementBuckets(); // Refresh data after deletion
              },
              error: async (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });
            break;
          case 'vpAmountBuckets':
            // this.vpAmountBuckets = [];

            const vpAmountBucketspayload = {
              companyId: this.loggedInUserCompanyID,
              fiscalYear: this.selectedYearForCompetency,
              deletedBy: this.loggedInUserId
            };

            this.httpService.callPutService(
              `${this.config.vpAmountBucketDeleteUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}&deletedBy=${this.loggedInUserId}`,
              vpAmountBucketspayload
            ).subscribe({
              next: (result: any) => {
                // this.snackbar.open("The VP Amount Bucket has been updated successfully.", "Close", { duration: 2000 });
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: 'The bucket has been deleted successfully.',
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: true,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
                this.fetchVpAmountBuckets(); // Refresh data
              },
              error: (err: any) => {
                this.dialog.open(ConfirmationPopupComponent, {
                  disableClose: true,
                  height: '25%',
                  width: '30%',
                  data: {
                    msg: err.error.message || "Failed to delete the bucket.",
                    btn1: 'Close',
                    btn2: '',
                    btn2BgColor: this.buttonColorName,
                    showSuccessIcon: false,
                    showSuccessMessage: false,
                    showCloseIcon: false
                  },
                });
              }
            });
            break;
        }
        this.ageGroupBucketsInput = false;

        this.yearBucketsInput = false;

        this.performanceBucketsInput = false;

        this.potentialBucketsInput = false;

        this.essScoreBucketsInput = false;

        this.salaryBucketsInput = false;

        this.incrementBucketsInput = false;

        this.vpAmountBucketsInput = false;
        this.errorMessage = ''; // Clear any error messages
      }
    });
  }

  preventDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === ',' || event.key === '-') {
      event.preventDefault();
    }
  }
  validateTextInput(event: KeyboardEvent) {
    const inputChar = event.key;
    const regex = /^[A-Za-z\s]+$/; // Only allow letters and spaces

    if (!regex.test(inputChar)) {
      event.preventDefault(); // Block the input if it's not a letter
    }
  }



  /////////////////////////////////// Bucket Get////////////////////////////////////////////////////

  fetchBucket() {
    this.fetchagegroupbucket();
    this.fetchYearBuckets();
    this.fetchPerformanceBuckets();
    this.fetchPotentialBuckets();
    this.fetchEssScoreBuckets();
    this.fetchSalaryBuckets();
    this.fetchIncrementBuckets();
    this.fetchVpAmountBuckets();
  }
  fetchagegroupbucket(): void {
    console.log("Company ID:", this.loggedInUserCompanyID);
    console.log("Selected Year:", this.selectedYearForCompetency, this.selectedYear);
    this.httpService.callGetService(`${this.config.agegroupbucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.ageGroupBuckets = data.data;
          console.log('ageGroupBuckets', this.ageGroupBuckets);
          // Transform data for X-axis labels
          // this.xAxisLabels = this.ageGroupBuckets.map(
          //   (bucket: any) => `${bucket.ageBucketLow}-${bucket.ageBucketMax}`
          // );
          const labels = this.ageGroupBuckets.map(
            (bucket: any) => `${bucket.ageBucketLow}-${bucket.ageBucketMax}`
          );
          const maxAge = this.ageGroupBuckets[this.ageGroupBuckets?.length - 1]?.ageBucketMax;
          labels.push(`${maxAge}+`);
          console.log("X-Axis Labels:", labels);
          this.PmsYearService.updateXAxisLabels(labels);

        },
        error: (err) => {
          console.error('Error fetching ageGroupBuckets:', err);
        }
      });
  }
  fetchYearBuckets(): void {
    this.httpService.callGetService(`${this.config.yearBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.yearBuckets = data.data;
          console.log('yearBuckets', this.yearBuckets);
        },
        error: (err) => {
          console.error('Error fetching year buckets:', err);
        }
      });
  }

  fetchPerformanceBuckets(): void {
    this.httpService.callGetService(`${this.config.performanceBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.performanceBuckets = data.data;
          console.log('performanceBuckets', this.performanceBuckets);
        },
        error: (err) => {
          console.error('Error fetching performance buckets:', err);
        }
      });
  }

  fetchPotentialBuckets(): void {
    this.httpService.callGetService(`${this.config.potentialBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.potentialBuckets = data.data;
          // this.potentialBuckets = Array.isArray(data) ? data : []; // Ensure it's an array

          console.log('potentialBuckets', this.potentialBuckets);
        },
        error: (err) => {
          console.error('Error fetching potential buckets:', err);
        }
      });
  }

  fetchEssScoreBuckets(): void {
    this.httpService.callGetService(`${this.config.essScoreBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.essScoreBuckets = data.data;
          // this.essScoreBuckets = Array.isArray(data) ? data : []; // Ensure it's an array

          console.log('essScoreBuckets', this.essScoreBuckets);
        },
        error: (err) => {
          console.error('Error fetching ESS score buckets:', err);
        }
      });
  }

  fetchSalaryBuckets(): void {
    this.httpService.callGetService(`${this.config.salaryBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.salaryBuckets = data.data;
          console.log('salaryBuckets', this.salaryBuckets);
        },
        error: (err) => {
          console.error('Error fetching salary buckets:', err);
        }
      });
  }

  fetchIncrementBuckets(): void {
    this.httpService.callGetService(`${this.config.incrementBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.incrementBuckets = data.data;
          console.log('incrementBuckets', this.incrementBuckets);
        },
        error: (err) => {
          console.error('Error fetching increment buckets:', err);
        }
      });
  }

  fetchVpAmountBuckets(): void {
    this.httpService.callGetService(`${this.config.vpAmountBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
      .subscribe({
        next: (data: any) => {
          this.vpAmountBuckets = data.data;
          console.log('vpAmountBuckets', this.vpAmountBuckets);
        },
        error: (err) => {
          console.error('Error fetching VP amount buckets:', err);
        }
      });
  }
}



